import type { LatLngLiteral } from '@shared/core/google-maps/types';

export interface EventLocation {
  place?: string | null;
  placeId?: string | null;
  lat?: number;
  lng?: number;
  detailedPlace?: string;
  country?: string;
}

export interface AccommodationsLocation {
  location: EventLocation;
  locationValue: string;
}

export type AccommodationsDestination = {
  name?: string | null;
  address?: string | null;
  lat?: number | null;
  long?: number | null;
  placeId?: string | null;
};

export type HotelListItemCart = {
  id?: string;
  placeId?: string | undefined;
  location?: LatLngLiteral | undefined;
  address?: string | undefined;
  displayName?: string | undefined;
  description?: string | undefined;
  photo?: string | undefined;
  rating?: number | undefined;
  ratingCount?: number | undefined;
  googlePlaceId?: string | undefined;
  fullAddress?: string | undefined;
  isPreferredHotel?: boolean | undefined;
  websiteUrl?: string | undefined;
  hasSelected?: boolean;
};

export interface EventDate {
  timeString?: string;
  dateString?: string;
}

export enum TravelMapBlockType {
  travelMapVenue = 'travelMapVenue',
  travelMapAccommodationsHotel = 'travelMapAccommodationsHotel',
  travelMapAccommodationsCustom = 'travelMapAccommodationsCustom',
  travelMapAccommodationsRoomblock = 'travelMapAccommodationsRoomblock',
}

export type HotelDetailsPdpDialog = {
  itemId?: string;
  joyPlaceId?: string | null;
  businessStatus?: string;
  distance?: number | null;
  rating?: number | undefined;
  displayName?: string;
  ratingCount?: number | undefined;
  address?: string;
  placeId?: string;
  photo?: string;
  description?: string;
  location?: LatLngLiteral;
  googlePlaceId?: string;
  fullAddress?: string;
  isPreferredHotel?: boolean;
  hasAddedHotel?: boolean;
  reservedRoomBlocks?: {
    roomBlockId: string;
  };
  websiteUrl?: string;
  url?: string;
  price?: string | number | null;
  strikeoutPrice?: string | number | null;
  zhId?: string;
  hasExclusiveBlockRate?: boolean;
  phone?: string;
};
